import { render, staticRenderFns } from "./RegistrationThanks.vue?vue&type=template&id=1d398806&scoped=true&"
import script from "./RegistrationThanks.vue?vue&type=script&lang=js&"
export * from "./RegistrationThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d398806",
  null
  
)

export default component.exports